/** One natural editor canvas frame is ready to reveal, not texture generation. */
export const EDITOR_RENDER_READY_EVENT = 'digitiles-editor-render-ready';
